import { FormicaTimePickerDate, QuickDate, QuickDateTypes } from './TimePickerDomain';
import moment from 'moment';

class DatePickerUtil {
  private readonly DATE_FORMAT = 'MMMM Do YYYY, H:mm:ss';
  private readonly LOCALE = localStorage.getItem('locale') || 'en-EN';

  private dates: Record<QuickDateTypes, QuickDate> = {
    [QuickDateTypes.THIS_MINUTE]: {
      startDate: {
        label: 'This minute',
        value: null,
        round: true,
        type: 'Relative',
      },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.LAST_MINUTE]: {
      startDate: {
        label: 'Last minute',
        value: null,
        round: true,
        type: 'Relative',
      },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.THIS_HOUR]: {
      startDate: {
        label: 'This hour',
        value: null,
        round: true,
        type: 'Relative',
      },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.LAST_HOUR]: {
      startDate: {
        label: 'Last hour',
        value: null,
        round: true,
        type: 'Relative',
      },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.TODAY]: {
      startDate: {
        label: 'Today',
        value: null,
        round: true,
        type: 'Relative',
      },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.YESTERDAY]: {
      startDate: {
        label: 'Yesterday',
        value: null,
        round: true,
        type: 'Relative',
      },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.THIS_WEEK]: {
      startDate: {
        label: 'This week',
        value: null,
        round: true,
        type: 'Relative',
      },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.LAST_WEEK]: {
      startDate: {
        label: 'Last week',
        value: null,
        round: true,
        type: 'Relative',
      },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.THIS_MONTH]: {
      startDate: {
        label: 'This month',
        value: null,
        round: true,
        type: 'Relative',
      },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.LAST_MONTH]: {
      startDate: {
        label: 'Last month',
        value: null,
        round: true,
        type: 'Relative',
      },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.THIS_YEAR]: {
      startDate: {
        label: 'This year',
        value: null,
        round: true,
        type: 'Relative',
      },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.LAST_YEAR]: {
      startDate: {
        label: 'Last year',
        value: null,
        round: true,
        type: 'Relative',
      },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.LAST_15_MINUTES]: {
      startDate: { label: 'Last 15 Minutes', value: moment().subtract(15, 'minute').toDate(), type: 'Quick' },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.LAST_30_MINUTES]: {
      startDate: { label: 'Last 30 Minutes', value: moment().subtract(30, 'minute').toDate(), type: 'Quick' },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.LAST_60_MINUTES]: {
      startDate: { label: 'Last 60 Minutes', value: moment().subtract(60, 'minute').toDate(), type: 'Quick' },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.LAST_6_HOUR]: {
      startDate: { label: 'Last 6 Hour', value: moment().subtract(6, 'hour').toDate(), type: 'Quick' },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.LAST_12_HOUR]: {
      startDate: { label: 'Last 12 Hour', value: moment().subtract(12, 'hour').toDate(), type: 'Quick' },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.LAST_24_HOUR]: {
      startDate: { label: 'Last 24 Hour', value: moment().subtract(24, 'hour').toDate(), type: 'Quick' },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.LAST_7_DAY]: {
      startDate: { label: 'Last 7 Day', value: moment().subtract(7, 'day').toDate(), type: 'Quick' },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.LAST_15_DAY]: {
      startDate: { label: 'Last 15 Day', value: moment().subtract(15, 'day').toDate(), type: 'Quick' },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.LAST_30_DAY]: {
      startDate: { label: 'Last 30 Day', value: moment().subtract(30, 'day').toDate(), type: 'Quick' },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.LAST_3_MONTHS]: {
      startDate: { label: 'Last 3 Months', value: moment().subtract(3, 'months').toDate(), type: 'Quick' },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.LAST_6_MONTHS]: {
      startDate: { label: 'Last 6 Months', value: moment().subtract(6, 'months').toDate(), type: 'Quick' },
      endDate: this.getNowDateObject(),
    },
    [QuickDateTypes.LAST_12_MONTHS]: {
      startDate: { label: 'Last 12 Months', value: moment().subtract(12, 'months').toDate(), type: 'Quick' },
      endDate: this.getNowDateObject(),
    },
  };

  private getNowDateObject(): FormicaTimePickerDate {
    return {
      label: 'Now',
      value: 'Now',
      type: 'Now',
    };
  }

  public getQuickDate(type: QuickDateTypes): QuickDate {
    return this.dates[type];
  }

  public getAllDates() {
    return this.dates;
  }

  public toConvertLocalDateString(date: Date): string {
    return date.toLocaleDateString(this.LOCALE);
  }

  public static calculateQuickValue(duration: number, unit: string): Date {
    return moment().subtract(duration, unit as moment.unitOfTime.DurationConstructor).toDate();
  }
}

export default DatePickerUtil;
